function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1009_11814)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.8 56.4C23.13 56.4 0 44.28 0 28.2C0 12.12 23.13 0 53.8 0C84.47 0 107.6 12.12 107.6 28.2C107.6 44.28 84.47 56.4 53.8 56.4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.8 51.4C80.7515 51.4 102.6 41.013 102.6 28.2C102.6 15.387 80.7515 5 53.8 5C26.8485 5 5 15.387 5 28.2C5 41.013 26.8485 51.4 53.8 51.4Z",
  stroke: "#161421",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.17 21.49H31.36V24.35H27.7V26.19H30.68V28.66H27.7V30.72H31.52V33.6H24.16V21.48L24.17 21.49Z",
  fill: "#161421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.64 31.78L38.28 30C38.2 29.58 37.84 29.27 37.45 29.27H36.82V33.6H33.15V21.48H38.01C41.07 21.48 42.88 22.95 42.88 25.44C42.88 26.93 42.1 28.1 40.82 28.52V28.54C41.43 28.76 41.7 29.22 41.84 29.94L42.04 31.02C42.09 31.38 42.23 31.55 42.48 31.55C42.67 31.55 42.87 31.46 43.06 31.28L43.65 32.96C43.02 33.52 41.97 33.87 41.09 33.87C39.75 33.87 38.84 33.04 38.64 31.77V31.78ZM37.86 26.89C38.69 26.89 39.21 26.35 39.21 25.52C39.21 24.64 38.69 24.12 37.86 24.12H36.83V26.89H37.86Z",
  fill: "#161421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.62 27.5499C44.62 23.6399 46.79 21.1499 50.15 21.1499C53.03 21.1499 55.06 23.0499 55.33 26.0899L51.95 26.4999C51.76 25.0999 51.09 24.2699 50.19 24.2699C49.02 24.2699 48.29 25.5199 48.29 27.5499C48.29 29.5799 49.14 30.7699 50.49 30.7699C51.64 30.7699 52.47 29.8199 52.67 28.3199L56.09 28.7399C55.72 31.8899 53.55 33.9499 50.49 33.9499C46.92 33.9499 44.62 31.4299 44.62 27.5499Z",
  fill: "#161421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.41 33.6097C58.6 30.2397 59.48 27.2097 61.42 24.3497H57.26V21.4897H64.79L64.81 24.0497C63.19 27.1097 62.37 30.2297 62.22 33.6097H58.41Z",
  fill: "#161421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.29 32.19C66.29 29.87 67.07 28.6 69.01 27.72L70.48 27.01C71.44 26.55 71.78 26.15 71.78 25.27C71.78 24.51 71.53 23.97 70.98 23.97C70.37 23.97 70.08 24.61 70.08 26.15L66.42 25.56C66.56 22.92 68.43 21.21 71.18 21.21C73.77 21.21 75.44 22.77 75.44 25.22C75.46 26.93 74.63 28.08 72.8 28.84L70.97 29.65C70.23 30.04 69.99 30.38 69.99 31H75.2V33.61H66.27V32.19H66.29Z",
  fill: "#161421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.0201 30.8697H78.8501V25.6197H78.8301C78.5601 26.1097 78.1501 26.4497 77.6101 26.6697L76.7001 23.9297C77.8301 23.5097 78.6501 22.6997 79.1401 21.4897H82.4101V30.8697H83.7601V33.6097H77.0301V30.8697H77.0201Z",
  fill: "#161421"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1009_11814"
}, /*#__PURE__*/React.createElement("rect", {
  width: 107.6,
  height: 56.4,
  fill: "white"
})));

function SvgSignErc721(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 57,
    viewBox: "0 0 108 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignErc721);
export default __webpack_public_path__ + "static/media/Sign_ERC721.f1b7c8c1.svg";
export { ForwardRef as ReactComponent };